import React from 'react';
import CustomTextField from '../../../RouteExecution/DriverPopUp/common/CustomTextField';
import Button from '@material-ui/core/Button';
import Select from '../../../../../common/StyledSelect';
import { Header, WithChatWindow } from '../../common';
import { ONLY_NUMBER_REGEX } from '../../../RouteExecution/constRegex';
import constants from '../../constants';
import { Urgent as UrgentButton } from './../../common/Buttons';

class EditCannedMessages extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editMsg: this.props.editMsg,
      value: '',
      errorInfo: '',
      isEditable: this.props.isEditable
    };
  }

  componentDidUpdate() {
    if (
      this.props.editMsg.type === 'select' &&
      this.state.value &&
      !this.props.pendingCustomers.includes(this.state.value)
    ) {
      this.setState({
        value: ''
      });
    }
  }

  sendEditMessage = () => {
    if (!this.state.value) {
      this.setState({ errorInfo: '* Required' });
      return;
    }
    const editedMessage = this.state.editMsg.text.replace('________', `${this.state.value} `);
    this.props.onMessageSubmit({ message: editedMessage, isUrgent: this.props.isUrgent });
    this.setState({
      value: '',
      editMsg: '',
      isEditable: false,
      errorInfo: ''
    });
  };
  handleChange = (value) => {
    this.setState({
      value,
      errorInfo: ''
    });
  };

  handleSelectChange = (event) => {
    this.setState({
      value: event?.value ?? '',
      errorInfo: ''
    });
  };

  cancelEditMessage = () => {
    this.setState({ editMsg: '', isEditable: false, value: '', errorInfo: '' });
    this.props.cancelEditMessage();
  };

  render() {
    const { classes, pendingCustomers, isUrgent, toggleUrgent } = this.props;
    const { editMsg } = this.state;

    const pendingCustomersOptions = pendingCustomers.map((name) => ({ label: name, value: name }));
    return (
      <>
        <Header title="Edit Message">
          <UrgentButton isMarkedAsUrgent={isUrgent} onClick={toggleUrgent} />
        </Header>
        <div className={`${classes.editCannedMessageContainer} customScroll`}>
          <div className={classes.listItemText}>{editMsg.text}</div>
          {editMsg.type !== 'none' && editMsg.type === 'select' ? (
            <div className={classes.flexRow}>
              <Select
                textFieldProps={{
                  id: 'customer',
                  label: '',
                  variant: 'outlined',
                  helperText: this.state.errorInfo
                }}
                value={this.state.value}
                onChange={this.handleSelectChange}
                error={Boolean(this.state.errorInfo)}
                data={pendingCustomersOptions}
              />
            </div>
          ) : (
            <CustomTextField
              id="number"
              label=""
              value={this.state.value}
              handleChange={this.handleChange}
              error={this.state.errorInfo}
              className={classes.textFieldClass}
              hideIncrementer
              autoFocus
              inputProps={{
                maxLength: constants.MAX_LENGTH_CONSTRAINTS.CANNED_VALUE,
                pattern: ONLY_NUMBER_REGEX,
              }}
            />
          )}
          <div>
            <Button onClick={this.cancelEditMessage} color="secondary">
              Cancel
            </Button>
            <Button color="primary" onClick={this.sendEditMessage}>
              Send
            </Button>
          </div>
        </div>
      </>
    );
  }
}

export default WithChatWindow(EditCannedMessages);
